import type { FC } from 'react';
import { PapiBadge, PapiUser } from '@wix/da-papi-types';
import BadgeActivity from './BadgeActivity';
import { BadgeActivityItem, BadgesByCategoryType } from '../../../../types/badge';
import BadgesByCategory from './BadgesByCategory';

import s from './MyBadges.scss';

export interface Props {
  className?: string;
  badges: PapiBadge[];
  badgesByCategory: BadgesByCategoryType;
  badgeActivity: BadgeActivityItem[];
  totalSent: number;
  totalReceived: number;
  isOwner: boolean;
  profileOwnerUser: PapiUser;
}

const MyBadges: FC<Props> = ({
  badges,
  badgesByCategory,
  badgeActivity,
  totalSent,
  totalReceived,
  isOwner,
  profileOwnerUser,
}) => {
  const widthBreakpoints = [640, 800];
  return (
    <>
      <BadgesByCategory
        className={s['section']}
        badgeCategories={badgesByCategory}
        widthBreakpoints={widthBreakpoints}
        profileOwnerUser={profileOwnerUser}
      />
      <BadgeActivity
        className={s['activities']}
        totalSent={totalSent}
        totalReceived={totalReceived}
        items={badgeActivity}
        isOwner={isOwner}
        ownerUsername={profileOwnerUser.username}
      />
    </>
  );
};
MyBadges.displayName = 'MyBadges';

export default MyBadges;
